import React from "react";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import { DeleteOutlined } from "@material-ui/icons";
import { obterTipoIconeBandeira } from "../utils/cartaoUtils";
import styles from "../styles/CartaoItem.module.scss";

/**
 * Componente reutilizavel para exibir um item de cartao de credito.
 *
 * @param {Object} cartao - Dados do cartao (ultimos_digitos, mes_validade, ano_validade, bandeira, pagamento_principal/principal)
 * @param {boolean} selecionado - Se o cartao esta selecionado
 * @param {Function} onClick - Callback ao clicar no cartao
 * @param {"selecionar"|"excluir"} modo - Modo de exibicao
 * @param {Function} onExcluir - Callback ao clicar em excluir (modo "excluir")
 */
export default function CartaoItem({ cartao, selecionado, onClick, modo = "selecionar", onExcluir }) {
  const eh_principal = cartao.pagamento_principal || cartao.principal;
  const tipo_icone = obterTipoIconeBandeira(cartao.bandeira);

  return (
    <div
      className={selecionado ? styles.cartaoItemSelecionado : styles.cartaoItem}
      onClick={onClick}
    >
      <div className={styles.cartaoEsquerda}>
        <PaymentIcon type={tipo_icone} format="logo" width={40} />

        <div className={styles.cartaoInfo}>
          <p className={styles.cartaoNumero}>
            Cartão de crédito ****{cartao.ultimos_digitos}
          </p>

          <p className={styles.cartaoValidade}>
            {String(cartao.mes_validade).padStart(2, "0")}/{cartao.ano_validade}
          </p>
        </div>
      </div>

      <div className={styles.cartaoDireita}>
        {eh_principal && (
          <span className={styles.badgePrincipal}>Principal</span>
        )}

        {modo === "selecionar" && (
          <input
            type="radio"
            className={styles.radioInput}
            checked={selecionado}
            onChange={() => {}}
          />
        )}

        {modo === "excluir" && onExcluir && (
          <button
            className={styles.botaoExcluir}
            onClick={(evento) => {
              evento.stopPropagation();
              onExcluir(cartao.id);
            }}
          >
            <DeleteOutlined />
          </button>
        )}
      </div>
    </div>
  );
}
